module.exports = __webpack_public_path__ + "2be9029a45f233d1749e18b44dedcef9.png";